import * as config from 'config';

export function url(path) {
  return `${config.API_URL}${path}`;
}
